import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { ReturnReasonAdapter } from './adapters/return-reason.adapter';
import { OccReturnReasonAdapter } from './adapters/impl/occ-return-reason.adapter';
import { ReturnCreationAdapter } from './adapters/return-creation.adapter';
import { OccReturnCreationAdapter } from './adapters/impl/occ-return-creation.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: ReturnReasonAdapter,
            useClass: OccReturnReasonAdapter,
        },
        {
            provide: ReturnCreationAdapter,
            useClass: OccReturnCreationAdapter,
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class OccModule {
}
